import styled, { css } from 'styled-components';

export const Container = styled.div`
  background-color: ${p => p.theme.c.snow};
  padding: 16px;

  h2 {
    text-align: center;
  }

`;

export const FormContainer = styled.div`
    max-width: 350px;
    display: block;
    margin: auto;
`;

export const Row = styled.div`
    ${p => p.theme.sm.min(css`
        display: flex;
        gap: 16px;
    `)}

`;